import { Sprite, Texture } from 'pixi.js';
import { Signal } from 'typed-signals';

import { Shared } from '../../App';
import { NineSliceButton } from './NineSliceButton';

const defaultOpts = {
    startHidden: false,
    startChecked: false,
};

export type CheckboxButtonOpts = typeof defaultOpts;

export class CheckboxButton extends NineSliceButton
{
    protected _checked: boolean;
    protected textureChecked: Texture;
    protected textureUnchecked: Texture;
    public onChecked: Signal<(checkbox: CheckboxButton) => void>;
    public onUnchecked: Signal<(checkbox: CheckboxButton) => void>;

    constructor(opts: Partial<CheckboxButtonOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };
        const icon = new Sprite();

        super({
            icon,
            accessibleTitle: 'Checkbox',
            bgAsset: 'tt-checkbox-ninesliced',
            w: 100,
            h: 100,
            startHidden: o.startHidden,
        });

        this.textureChecked = Shared.assets.getTexture('icon-tick');
        this.textureUnchecked = Shared.assets.getTexture('icon-tick-grey');
        this._checked = o.startChecked;
        this.icon.texture = o.startChecked ? this.textureChecked : this.textureUnchecked;
        this.onPress.connect(() => this.toggleChecked());
        this.onChecked = new Signal();
        this.onUnchecked = new Signal();
    }

    public get checked(): boolean
    {
        return this._checked;
    }

    public set checked(v: boolean)
    {
        if (this._checked === v) return;
        this._checked = v;
        this.icon.texture = v ? this.textureChecked : this.textureUnchecked;
    }

    public toggleChecked(): void
    {
        if (!this.enabled) return;
        this.checked = !this.checked;
        this._checked ? this.onChecked.emit(this) : this.onUnchecked.emit(this);
    }
}
